import React from 'react';
import { PlusIcon as HeroPlusIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type PlusIconProps = Omit<IconProps, 'children'>;

export const PlusIcon: React.FC<PlusIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroPlusIcon />
        </Icon>
    );
};
